import React, {useEffect, useState} from 'react';
import "./onboard-countdown-style.scss";
import {setCInterval, stopCInterval} from "../../../util/CustomSetInterval";

const OnboardCountdown = () => {

    const firstTime = 30;
    const secondTime = 60;

    const [size, setSize] = useState(0);
    const [count, setCount] = useState(firstTime);
    const [startAnimation, setStartAnimation] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            handleCount(() => {
                setSize(1);
                handleCount(() => {
                }, secondTime);
            }, firstTime);
        }, 500);
    }, []);

    const handleCount = (callback, number) => {
        stopCInterval("countdown");
        let countdown = number;
        setCount(number);
        setStartAnimation(true);
        setCInterval("countdown", () => {
            countdown = --countdown <= 0 ? number : countdown;
            setCount(countdown);
            if (countdown === number) callback();
        }, 1000)
    }

    return (
        <div id="countdown">
            <div id="countdown-number">{count}</div>
            <svg>
                <defs>
                    <linearGradient id="gradient-stroke2" x1="0%" y1="100%" x2="100%" y2="0%">
                        <stop offset="25.78%" stopColor="#DEDEDE"/>
                        <stop offset="74.17%" stopColor="#DEDEDE"/>
                    </linearGradient>
                </defs>
                <circle stroke="url(#gradient-stroke2)" r="36" cx="50" cy="50"></circle>
            </svg>
            <svg>
                <defs>
                    <linearGradient id="gradient-stroke" x1="0%" y1="100%" x2="100%" y2="0%">
                        <stop offset="25.78%" stopColor="#D30612"/>
                        <stop offset="74.17%" stopColor="#AA050E"/>
                    </linearGradient>
                </defs>
                {size === 0 &&
                    <circle stroke="url(#gradient-stroke)" className={startAnimation ? 'countdown-animation' : ''}
                            r="36" cx="50" cy="50"></circle>}
                {size === 1 &&
                    <circle stroke="url(#gradient-stroke)" className={startAnimation ? 'countdown-animation-2' : ''}
                            r="36" cx="50" cy="50"></circle>}
            </svg>
        </div>
    )
};

export default OnboardCountdown;
